import { Link } from "react-router";
import { ROUTES } from "../links";
import { LegalPage, MailLink } from "./LegalPage";

/**
 * Terms of Service, verbatim from the Google Doc 1KICnhrAzuECHbYmJHuOCVHEg590e8Vw-H93_GgyHZdw.
 * Formatting only: each numbered clause's title is a heading, bullets are lists, the Privacy
 * Policy and the email address are links.
 */
export function TermsPage() {
  return (
    <LegalPage slug="terms" title="Terms of Service">
      <p>
        Welcome to WealthyPlanet! These Terms of Service (&quot;Terms&quot;) govern your access to
        and use of our website, platform, and services (collectively, the &quot;Services&quot;). By
        accessing or using our Services, you agree to be bound by these Terms. If you do not agree
        to these Terms, do not use our Services.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By using WealthyPlanet, you confirm that you are at least 18 years old and have the legal
        capacity to enter into these Terms. If you are using our Services on behalf of an
        organization, you represent that you have the authority to bind that organization
      </p>

      <h2>2. Changes to Terms</h2>
      <p>
        We may modify these Terms at any time. Any changes will be posted on our website, and your
        continued use of the Services after the changes take effect constitutes your acceptance of
        the updated Terms.
      </p>

      <h2>3. Use of Services</h2>
      <ul>
        <li>
          You agree to use our Services only for lawful purposes and in accordance with these Terms.
        </li>
        <li>
          You may not engage in any activity that disrupts or interferes with our Services or
          violates any applicable laws.
        </li>
        <li>
          You are responsible for maintaining the confidentiality of your account credentials and
          all activities that occur under your account.
        </li>
      </ul>

      <h2>4. Account Registration</h2>
      <p>
        To access certain features of our Services, you may be required to register an account. You
        agree to provide accurate and complete information and to update your account as needed to
        keep it accurate.
      </p>

      <h2>5. Privacy Policy</h2>
      <p>
        Your use of our Services is also governed by our{" "}
        <Link to={ROUTES.privacy}>Privacy Policy</Link>, which outlines how we collect, use, and
        protect your data.
      </p>

      <h2>6. Intellectual Property</h2>
      <ul>
        <li>
          WealthyPlanet and its content, including but not limited to text, graphics, logos, and
          software, are owned by or licensed to us and are protected by intellectual property laws.
        </li>
        <li>
          You may not copy, distribute, or create derivative works of our content without our
          express written permission.
        </li>
      </ul>

      <h2>7. Disclaimers and Limitation of Liability</h2>
      <ul>
        <li>Our Services are provided &quot;as is&quot; without warranties of any kind.</li>
        <li>
          WealthyPlanet is not responsible for any financial decisions you make based on our
          Services.
        </li>
        <li>
          To the fullest extent permitted by law, WealthyPlanet shall not be liable for any
          indirect, incidental, special, or consequential damages arising from your use of the
          Services.
        </li>
      </ul>

      <h2>8. Termination</h2>
      <p>
        We reserve the right to suspend or terminate your access to the Services at any time if you
        violate these Terms or engage in conduct that we determine to be inappropriate.
      </p>

      <h2>9. Governing Law</h2>
      <p>These Terms shall be governed by and construed in accordance with the laws of Canada.</p>

      <h2>10. Contact Us</h2>
      <p>
        If you have any questions or concerns about these Terms, please contact us at <MailLink />.
      </p>

      <p>
        By using WealthyPlanet, you acknowledge that you have read, understood, and agreed to these
        Terms of Service.
      </p>
    </LegalPage>
  );
}
